var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex justify-between" }, [
    _c("div", { staticClass: "title" }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
    ]),
    _c(
      "div",
      { staticClass: "title-right" },
      [
        _vm._t("select"),
        _vm.clickable
          ? _c(
              "div",
              {
                staticClass: "more",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.goDashboard.apply(null, arguments)
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("client_home.more")) +
                    "\n        "
                ),
              ]
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }